/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmKrokTrasy extends GContentBase<SeznamAdmKrokTrasyObj> {
        private seznamObj: SeznamAdmKrokTrasyObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmKrokTrasyObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmKrokTrasyNew",
                contentCaption: "jres:33000797", //RC 33000797 : Kroky trasy dokumentu
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_tra} - {poradi}"
                },
                gridSettings: {
                    columnOrder: this.columnOrder()
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }

        private columnOrder(): string {
            if (this.wfl_trasy_new == true) {
                return `${(this.ixs_tra == null || this.ixs_tra == undefined) ? "ixs_tra_txt," : ""}poradi,typ_krok_txt,typ_dnu_termin_txt,ixs_fun_pov_txt,nazev,poznamka,ixs_fun_txt,ixs_su_txt,dat_zmena,zmenu_prov_txt`
            }
            else {
                return `${(this.ixs_tra == null || this.ixs_tra == undefined) ? "ixs_tra_txt," : ""}poradi,typ_krok_txt,ixs_fun_txt,nazev,poznamka,dat_zmena,zmenu_prov_txt`
            }
        }
    }

    export class SeznamAdmKrokTrasyObj extends GAdmSeznamBase {
        ixs_tra: string;
        wfl_trasy_new: boolean;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate([this.wfl_trasy_new == true ? "Gordic.Adm.WebControls.DetailAdmKrokTrasy" : "Gordic.Adm.WebControls.DetailAdmKrokTrasyPuvodni", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmKrokTrasy",
                newRecord: isNew,
                ixs_tra: isNew == true ? ((this.ixs_tra) ? this.ixs_tra : null ) : data.ixs_tra,
                por_cislo: isNew == true ? null : data.por_cislo
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*"
            ])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000798").addField("gselectbox", Gordic.Prefabs.Select.wflstra(), { //RC 33000798 : Trasa dokumentu
                dropdown: true,
                model: "model.ixs_tra=value.ixs_tra",
                name: "ixs_tra",
                disabled: (this.ixs_tra) ? true : false
            }) 
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_tra)
                hardFilter["ixs_tra"] = this.ixs_tra
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_tra)
                data["ixs_tra"] = this.ixs_tra
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmKrokTrasy.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
           
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_tra}#${data.poradi}#`,
                nazev: data["nazev"]
            }
        }
    }
}